import { render } from "./EditPasswordForm.vue?vue&type=template&id=1697d68e"
import script from "./EditPasswordForm.vue?vue&type=script&lang=js"
export * from "./EditPasswordForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1697d68e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1697d68e', script)) {
    api.reload('1697d68e', script)
  }
  
  module.hot.accept("./EditPasswordForm.vue?vue&type=template&id=1697d68e", () => {
    api.rerender('1697d68e', render)
  })

}

script.__file = "src/components/forms/EditPasswordForm.vue"

export default script